import { $applyNodeReplacement } from "lexical";
import { ImagesGalleryNode } from "./ImagesGalleryNode.js";
function $createImagesGalleryNode(images, editor, description) {
    return $applyNodeReplacement(new ImagesGalleryNode(images, editor, description));
}
function $isImagesGalleryNode(node) {
    return node instanceof ImagesGalleryNode;
}
export { $createImagesGalleryNode, $isImagesGalleryNode };
